export const isParticipantChild = (role) =>{
    if(role === 'r_parent_nsv' || role === 'r_parent_sv'){
        return true
    }
    return false;
}